import React,{useState, useEffect} from "react";
import Header from "./Components/Header";
import Footer from "./Components/Footer";
import Gallery from "./Components/Gallery";
import GalleryEdit2 from "./Components/GalleryEdit2";
import GalleryEdit3 from "./Components/GalleryEdit3";
import GalleryEdit4 from "./Components/GalleryEdit4";
import "./CSS/Gallerypage.css";
import Loader from "./Components/Loader";

const GalleryPage=()=>{
    return(
        <>
            <Header/>
            <Gallery/>
            
            <GalleryEdit3/>
            <GalleryEdit2/>
            <GalleryEdit4/>
            <Loader/>
            <Footer/>   
        </>
    );
}

export default GalleryPage;